import { css } from '@emotion/react';
import { AccountPasswordForm } from './forms/AccountPasswordForm';

export const ScreenAccountPassword = () => {
	return (
		<div
			css={css`
				display: flex;
				padding: 32px;
				width: 580px;
				flex-direction: column;
			`}
		>
			<AccountPasswordForm />
		</div>
	);
};
